import {Component, HostListener, OnInit, ViewChild, ElementRef} from '@angular/core';
import {animation} from '../../shared/animations/animations';
import {Router} from '@angular/router';
import {AuthTokenService} from '../../shared/services/auth-token.service';

import {PeopleService} from './people.service';
import {SurveyService} from './../surveys/surveys.service';
import {
  PeopleSearchPDModel,
  PeopleFilterModel,
  PeopleModel,
  SelectedPeoplesToSurvey,
  FileUploadModel,
  CsvImportModel, EnumModel
} from './../../models/people/people.model';
import {SurveyCreatePDModel} from './../../models/survey/survey.model';
import {DataTransferService} from './../../shared/services/data-transfer.service';
import {DropdownComponent} from './../../shared/components/dropdown/dropdown.component';
import {Toast, ToasterService} from 'angular5-toaster/dist';
import {SurveySearchPDModel} from "../../models/survey/survey.model";
import {environment} from './../../../environments/environment';
import {DxDataGridComponent} from "devextreme-angular";
import data from "devextreme/bundles/dx.all";
import {SidebarService} from "../../shared/services/sidebar.service";


@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.less'],
  animations: [animation],

})
export class PeopleComponent implements OnInit {

  objectField: string;
  dropdownLabel: any;
  tableOptions: any;
  peopleFilter: PeopleFilterModel;
  peopleSearchVisible: PeopleSearchPDModel;
  peopleSearch: PeopleSearchPDModel;
  visiblePeopleList: PeopleModel[];
  selectedPeopleList: PeopleModel[];
  selectAllPeople: boolean;
  selectedPeoplesToSurvey: SelectedPeoplesToSurvey;
  showSurveyList: boolean;
  showLoader: boolean;
  allMode: string = 'allPages';
  checkBoxesMode: string = 'onClick';
  surveyCreatePDModel: SurveyCreatePDModel;
  surveySearchPDModel: SurveySearchPDModel;
  incompleteSurveys: any;
  info = false;
  infoText: string;
  showUserPopup = false;
  user = new PeopleModel();
  showDeletePopup: boolean;

  importCSVPeoples: PeopleModel[];
  importCSVPeople: PeopleModel;

  @ViewChild('ddSource') ddSource: DropdownComponent;
  @ViewChild('ddSurvey') ddSurvey: DropdownComponent;
  @ViewChild('ddLocation') ddLocation: DropdownComponent;
  @ViewChild('ddGender') ddGender: DropdownComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

  constructor(private peopleService: PeopleService,
              private router: Router,
              private sidebarService: SidebarService,
              private toasterService: ToasterService,
              private surveyService: SurveyService) {
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode === 27) {
      this.showFilter(false);
    }
  }

  deleteEnumModel: EnumModel;

  ngOnInit() {
    // this.dataGrid.pagerChange.subscribe((e) => {
    //   console.log(e);
    // })
    // this.dataGrid.onContentReady.subscribe((e) => {
    //   console.log(this.dataGrid.paging);
    //   this.dataGrid.pagingChange.subscribe(e => {
    //     console.log(e);
    //   });
    // const dxPageSizeAll = document.getElementsByClassName('dx-page-size')[0] as HTMLElement;
    // if (dxPageSizeAll) {
    //   dxPageSizeAll.innerText = 'All';
    //   dxPageSizeAll.addEventListener('click', () => {
    //     e.component.pageSize(0);
    //     dxPageSizeAll.innerText = 'All';
    //   });
    // }
    // });

    this.deleteEnumModel = {id: "DeletePeople", name: "Delete People", value: "DeletePeople"};
    this.showLoader = true;
    this.objectField = 'name';
    this.dropdownLabel = {
      select: 'Select',
      actions: 'Actions'
    };
    this.initFilter();
    this.tableOptions = {
      column: 'lastName',
      isDesc: false
    };
    this.selectedPeopleList = [];
    this.selectAllPeople = false;
    this.selectedPeoplesToSurvey = new SelectedPeoplesToSurvey();
    this.showSurveyList = false;

    this.surveyService.getSurveyPDModel(null).subscribe(
      (response) => {
        this.surveySearchPDModel = response;
        this.incompleteSurveys = this.surveySearchPDModel.listSurveyItem.filter(x => x.status != 'ClosedIncomplete' && x.status != 'ClosedComplete');
      },
      (error) => {
        // console.log(error);
      }
    );


    this.peopleService.getPeopleSearchPD().subscribe(
      (response) => {
        // console.log(response);
        this.peopleSearch = response;
        this.peopleSearch.listEnumModelSurveyActions.push(this.deleteEnumModel);
        console.log(this.peopleSearch.listEnumModelSurveyActions);
        this.filterPeoples(false);
        this.showLoader = false;
      },
      (error) => {
        // console.log(error);
        this.showLoader = false;
      }
    );
  }

  showPeoplePopup(event) {
    this.user = event.data;
    this.showUserPopup = true;
    this.showFilter(false);
  }


  initFilter() {
    this.peopleFilter = {
      filterOn: true,
      dateLastInteraction: new Date().toString(),
      city: null,
      ageFrom: 0,
      ageTo: 0,
      genderId: null,
      surveyId: null,
      sourceId: null,
      userActivity: 0
    }
  }

  selectAll(e) {
    let select: boolean = e.target.checked;
    this.selectedPeopleList = [];
    for (let i = 0; i < this.visiblePeopleList.length; i++) {
      if (select) this.selectedPeopleList.push(this.visiblePeopleList[i]);
      this.visiblePeopleList[i].checked = select;
    }
  }

  peopleSelected(e) {
    this.selectedPeopleList = e.selectedRowsData;
    // if (bool) {
    //   this.selectedPeopleList.push(people);
    // } else {
    //   let index: number = this.selectedPeopleList.indexOf(people);
    //   this.selectedPeopleList.splice(index, 1);
    // }
    this.selectAllPeople = this.selectedPeopleList.length === this.visiblePeopleList.length;
  }

  showFilter(open: boolean) {
    this.peopleFilter.filterOn = open;
  }

  filterPeoples(filter) {
    if (filter === false) {
      this.visiblePeopleList = this.peopleSearch.listPeople.slice(0);
    }
    else {
      console.log(this.peopleSearch.listPeople);
      // this.visiblePeopleList = this.peopleSearch.listPeople.filter(
      //   people => {
      //     return people.checked === filter
      //   }
      // );
      this.visiblePeopleList = this.selectedPeopleList;
      console.log(this.visiblePeopleList);
    }
  }

  sort(column) {
    this.tableOptions.isDesc = !this.tableOptions.isDesc;
    this.tableOptions.column = column;
    const direction = this.tableOptions.isDesc ? 1 : -1;

    this.visiblePeopleList.sort(function (a, b) {
      if (a[column] < b[column]) {
        return -1 * direction;
      }
      else if (a[column] > b[column]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  selectedPplsToSurvey(e) {

    this.showLoader = true;

    switch (e.id) {
      case 'AddToExistingSurvey':
        this.showSurveyList = true;
        this.showLoader = false;
        break;
      case 'CreateNewSurveyFromSelection':
        this.selectedPeoplesToSurvey.listSelectedPeople = [];
        for (let i = 0; i < this.selectedPeopleList.length; i++) {
          this.selectedPeoplesToSurvey.listSelectedPeople.push(this.selectedPeopleList[i].id);
        }
        this.peopleService.createNewSurveyFromSelection(this.selectedPeoplesToSurvey).subscribe(
          (response) => {
            this.showLoader = false;
            this.surveyCreatePDModel = response;
            DataTransferService.PushData('SurveyCreatePDModel', this.surveyCreatePDModel);
            this.router.navigate(['surveys/new']);
          },
          (error) => {
            this.showLoader = false;
            // console.log(error);
          }
        );
        break;
      case 'DeletePeople':
        this.showLoader = false;
        this.showDeletePopup = true;
        break;
    }


    // if (e.id === 'AddToExistingSurvey') {
    //   this.showSurveyList = true;
    // }
    // else if (e.id === 'CreateNewSurveyFromSelection') {
    //   this.selectedPeoplesToSurvey.listSelectedPeople = [];
    //   for (let i = 0; i < this.selectedPeopleList.length; i++) {
    //     this.selectedPeoplesToSurvey.listSelectedPeople.push(this.selectedPeopleList[i].id);
    //   }
    //   this.peopleService.createNewSurveyFromSelection(this.selectedPeoplesToSurvey).subscribe(
    //     (response) => {
    //       this.showLoader = false;
    //       this.surveyCreatePDModel = response;
    //       DataTransferService.PushData('SurveyCreatePDModel', this.surveyCreatePDModel);
    //       this.router.navigate(['surveys/new']);
    //     },
    //     (error) => {
    //       this.showLoader = false;
    //       // console.log(error);
    //     }
    //   );
    // }
  }

  deletePeople() {
    console.log(this.selectedPeopleList);
    console.log(this.selectedPeopleList.map(x => x.id));
    this.showLoader = true;
    this.showDeletePopup = false;
    this.peopleService.deletePeople(this.selectedPeopleList.map(x => x.id)).subscribe(res => {
      if (res) {
        this.sidebarService.menuData.totalPeople = res.length;
      }
      this.visiblePeopleList = this.visiblePeopleList.filter(x => {
        let forDelete = true;
        this.selectedPeopleList.forEach(y => {
          if (x.id == y.id) {
            forDelete = false;
          }
        });
        return forDelete;
      });
      this.toasterService.pop('success', "Successfully deleted people");
      this.peopleSearch.listPeople = res;
      this.showLoader = false;
    });
  }

  onUserActivityChange(e) {
    this.peopleFilter.userActivity = e.target.valueAsNumber;
    console.log(this.peopleFilter);
  }

  addToExistingSurvey(e) {
    this.showLoader = true;
    this.selectedPeoplesToSurvey.listSelectedPeople = [];
    for (let i = 0; i < this.selectedPeopleList.length; i++) {
      this.selectedPeoplesToSurvey.listSelectedPeople.push(this.selectedPeopleList[i].id);
    }
    this.selectedPeoplesToSurvey.surveyId = e;
    this.peopleService.addPeopleToExistingSurvey(this.selectedPeoplesToSurvey).subscribe(
      (response) => {
        this.showLoader = false;
      },
      (error) => {
        this.showLoader = false;
        // console.log(error);
      }
    );

  }


  applyFilter() {
    if (this.peopleFilter.city == 'Any') {
      this.peopleFilter.city = null;
    }
    if (this.peopleFilter.genderId == 'Any') {
      this.peopleFilter.genderId = null;
    }
    this.peopleService.filterPeople(this.peopleFilter).subscribe(
      (response) => {
        this.peopleSearch.listPeople = response.listPeople;
        this.filterPeoples(false);
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  resetFilter() {
    // this.ddSource.dropdownLabel = "Select";
    this.ddSurvey.dropdownLabel = "Select";

    if (this.peopleFilter.sourceId == 1) {
      this.ddSurvey.dropdownLabel = "Select";
    }
    this.ddLocation.dropdownLabel = "Select";
    this.ddGender.dropdownLabel = "Select";
    this.initFilter();
  }

  uploadCSV() {
    document.getElementById('csvfile').click();
  }

  importCSV(e) {
    let allFiles = e.target.files;
    let fileReaded = allFiles[0];
    let reader: FileReader = new FileReader();
    reader.readAsText(fileReaded);

    reader.onload = (e) => {
      let csv: string = reader.result;
      let allTextLines = csv.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(',');

      // firstName,lastName,email,dob,gender,city,country

      if (headers.length != 7) {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'CSV file requires 7 columns',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);
      }
      else if (allTextLines[0].toLowerCase() != 'firstname,lastname,email,dob,gender,city,country') {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'Required header is: firstname,lastname,email,dob,gender,city,country',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);
      }
      else {
        this.showLoader = true;

        this.peopleService.csvUpload(allFiles).subscribe(
          (response) => {

            let responseModel = new CsvImportModel();
            responseModel = response;


            const toast: Toast = {
              type: responseModel.success == true ? 'success' : 'error',
              title: responseModel.success == true ? 'Success' : 'Error',
              body: responseModel.success == true ? 'Import completed' : responseModel.errorMessage,
              showCloseButton: true,
              timeout: 5000
            };

            this.toasterService.pop(toast);

            if (responseModel.success) {
              // filter by new source
              this.peopleSearch.listSource = responseModel.sources;
              this.initFilter();
              this.peopleFilter.sourceId = responseModel.sourceId;
              this.applyFilter();
              this.showLoader = false;
            }
            else
              this.showLoader = false;


          },
          (error) => {

            this.showLoader = false;

            const toast: Toast = {
              type: 'error',
              title: 'Error',
              body: error,
              showCloseButton: true,
              timeout: 5000
            };

            this.toasterService.pop(toast);
          }
        );

      }

    }
    // let lines = [];

    // this.importCSVPeoples = [];

    // for (let i = 0; i < allTextLines.length; i++) {
    //   let data = allTextLines[i].split(',');
    //   if (data.length === headers.length) {

    //     let dateOfBirth = new Date(data[3]);
    //     let today = new Date();
    //     let age = today.getFullYear() - dateOfBirth.getFullYear();
    //     dateOfBirth.setFullYear(today.getFullYear());
    //     if (today<dateOfBirth) {
    //       age--;
    //     }

    //     this.importCSVPeople = new PeopleModel();
    //     this.importCSVPeople.firstName = data[0];
    //     this.importCSVPeople.lastName = data[1];
    //     this.importCSVPeople.email = data[2];
    //     this.importCSVPeople.dob = data[3];
    //     this.importCSVPeople.city = data[4];
    //     this.importCSVPeople.country = data[5];
    //     this.importCSVPeople.sourceName = data[6];
    //     this.importCSVPeople.gender = data[7];
    //     this.importCSVPeople.age = age;
    //     this.importCSVPeoples.push(this.importCSVPeople);
    //   }
    // }
    // this.peopleSearch.listPeople = this.peopleSearch.listPeople.concat(this.importCSVPeoples);
    // this.filterPeoples(false);
    //}
  }

  updateFilter(e: any, filed: string) {
    switch (filed) {
      case 'source':
        this.peopleFilter.sourceId = e.id;
        break;
      case 'location':
        this.peopleFilter.city = e;
        break;
      case 'gender':
        this.peopleFilter.genderId = e.id;
        break;
      case 'survey':
        this.peopleFilter.surveyId = e.id;
        break;
    }
  }

  // todo show info
  showInfo() {
    this.infoText = environment.appUrl + 'welcome';
    this.info = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/people/people.component.ts